import { Fragment, useEffect, useState } from 'react'
import { useField } from 'remix-validated-form'
import ComboMultiSelect, { ComboMultiSelectProps } from 'app/components/ui/combo/combo-multi-select'
import FormInputWrapper, { FormInputWrapperProps } from './FormInputWrapper'
import { OptionType } from 'types/OptionType'

type MultiSelectComboboxProps = Omit<FormInputWrapperProps<any>, `onChange`> &
  ComboMultiSelectProps & { labelClassName: string }
/**
 * Multi Select Combobox that receives options from props
 * @summary IMPORTANT: the input value will be the entire option object, so the validation schema that parses this input needs to refine the value like this:
 *
 * `comboVal: z.object({ value: z.string(), id: z.string(), name: z.string() }).transform((option) => option.value)`
 * @param {MultiSelectComboboxProps} props - queryURL needs to be the path to an api route i.e. /api/locations
 */
export default function FormComboMultiSelect({
  name,
  label,
  cols,
  wrapperClassName,
  labelClassName,
  inputClassName,
  newLineError,
  addText,
  onChange,
  onAddNewValue,
  ...props
}: MultiSelectComboboxProps) {
  const { error, setTouched } = useField(name)
  const [selected, setSelected] = useState<OptionType[]>(props.values ?? [])
  useEffect(() => {
    setSelected(props.values ?? [])
  }, [props.values])
  const changeHandler = (options: OptionType[]) => {
    setTouched(true)
    setSelected(options)
    onChange?.(options)
  }
  return (
    <>
      {selected.map((opt, i) => (
        <Fragment key={opt.id ?? `${name}-${i}`}>
          <input type="hidden" name={`${name}[${i}][id]`} value={opt.id ?? ``} />
          <input type="hidden" name={`${name}[${i}][name]`} value={opt.name ?? ``} />
          <input type="hidden" name={`${name}[${i}][value]`} value={opt.value ?? ``} />
        </Fragment>
      ))}
      <FormInputWrapper
        {...{
          name,
          label,
          error,
          newLineError,
          cols,
          wrapperClassName,
          className: labelClassName,
          infoTooltip: props.infoTooltip,
        }}
      >
        <ComboMultiSelect
          {...props}
          name={name}
          inputClassName={inputClassName}
          addText={addText}
          onChange={changeHandler}
          onAddNewValue={onAddNewValue}
        />
      </FormInputWrapper>
    </>
  )
}
